// extracted by mini-css-extract-plugin
export var label = "_db-5";
export var slideContainer = "_db-0";
export var slider = "_db-1";
export var sliderLg = "_db-4";
export var sliderMd = "_db-3";
export var sliderSm = "_db-2";